import { Component, TemplateRef, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
    selector: 'app-custom-tooltip',
    template: `
    <ng-template #tooltipTemplate>
      <div class="tooltip-container-fix" (mouseenter)="clearTimer()" (mouseleave)="hide()">
        <ng-content></ng-content>
      </div>
    </ng-template>
  `,
    styles: [`
    .tooltip-container-fix {
      background: #333;
      color: white;
      padding: 10px 15px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.4);
      font-size: 14px;
      animation: tooltipIn 0.15s ease-out;
    }
    @keyframes tooltipIn {
      from { opacity: 0; transform: scale(0.9); }
      to { opacity: 1; transform: scale(1); }
    }
  `]
})
export class CustomTooltipComponent {
    @ViewChild('tooltipTemplate') tooltipTemplate!: TemplateRef<any>;
    private overlay = inject(Overlay);
    private viewContainerRef = inject(ViewContainerRef);
    private overlayRef: OverlayRef | null = null;
    private timeoutId: any;

    show(origin: HTMLElement) {
        this.clearTimer();
        if (this.overlayRef) return;

        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(origin)
            .withPositions([
                { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 8 },
                { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -8 }
            ]);

        this.overlayRef = this.overlay.create({ positionStrategy });
        this.overlayRef.attach(new TemplatePortal(this.tooltipTemplate, this.viewContainerRef));
    }

    hide() {
        this.timeoutId = setTimeout(() => {
            this.overlayRef?.detach();
            this.overlayRef = null;
        }, 150);
    }

    clearTimer() { if (this.timeoutId) clearTimeout(this.timeoutId); }
}